module.exports = function getResource(label, vars = []) {
    const resources = {
        scanCards: 'Scan cards',
        scanAtCheckout: 'Scan at checkout',
        showBarcode: 'Show barcode to a cashier to collect points or use rewards.'

    };
    return resources[label];
};
